export type ConversionDirection = 'MAD_TO_EUR' | 'EUR_TO_MAD'

export const CONVERSION_FAVORITES_MAD: readonly number[] = Object.freeze([50, 100, 200, 500, 1_000])

function roundCurrency(value: number): number {
  return Math.round((value + Number.EPSILON) * 100) / 100
}

export function validateConversionRate(rate: number): number {
  if (!Number.isFinite(rate) || rate <= 0 || rate > 1_000) {
    throw new Error('Le taux MAD pour 1 EUR doit être un nombre positif raisonnable.')
  }
  return rate
}

export function convertAmount(
  amount: number,
  direction: ConversionDirection,
  madPerEur: number,
): number {
  if (!Number.isFinite(amount) || amount < 0 || amount > 1_000_000_000) {
    throw new Error('Le montant doit être un nombre positif raisonnable.')
  }
  const rate = validateConversionRate(madPerEur)
  return roundCurrency(direction === 'MAD_TO_EUR' ? amount / rate : amount * rate)
}

export function divideForGroup(amount: number, people = 6): number {
  if (!Number.isInteger(people) || people <= 0) throw new Error('Le nombre de personnes doit être positif.')
  if (!Number.isFinite(amount) || amount < 0) throw new Error('Le montant doit être positif.')
  return roundCurrency(amount / people)
}
